import { css } from '@emotion/react'
import { StickyContainer } from 'bold-ui'
import { useOffsetAlerta } from 'hooks/useOffsetAlerta'

interface AlertStickyContainerProps {
  children: React.ReactNode
}

export function AlertStickyContainer({ children }: AlertStickyContainerProps) {
  const offsetAlerta = useOffsetAlerta()

  return (
    <StickyContainer
      top={offsetAlerta}
      style={css`
        z-index: 15;
      `}
    >
      {children}
    </StickyContainer>
  )
}
